import { selectFilterId } from '../selectors';
import * as types from '../types';

function setFeatureActive(featureId, isActive, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());
        return dispatch(_setFeatureActive(filterId, featureId, isActive));
    };
}

function _setFeatureActive(filterId, featureId, isActive) {
    return {
        meta: {
            filterId,
            featureId,
        },
        payload: isActive,
        type: types.SET_FEATURE_ACTIVE,
    };
}

function resetFeatures(filterId) {
    return (dispatch, getState) => {
        filterId = filterId || selectFilterId(getState());
        return dispatch(_resetFeatures(filterId));
    };
}

function _resetFeatures(filterId) {
    return {
        meta: filterId,
        type: types.RESET_FEATURES,
    };
}

export {
    resetFeatures,
    setFeatureActive,
};
